import { render } from "./InOnLaysLongevity.vue?vue&type=template&id=2b5e2d29"
import script from "./InOnLaysLongevity.vue?vue&type=script&lang=js"
export * from "./InOnLaysLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__